exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#inspectionCardModal .v--modal-box.v--modal{min-height:340px!important;min-width:440px!important}#inspectionCardModal .v-tabs__div:not(:last-child){padding-right:5px}#inspectionCardModal .v-tabs__div{background-image:linear-gradient(180deg,#2a579a 0,#2a579a),linear-gradient(180deg,#fff 0,#fff);background-clip:content-box,padding-box}#inspectionCardModal .v-select__selection{font-size:12px!important}#inspectionCardModal .v-subheader{font-size:14px!important;color:#000!important;font-weight:600!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35af812c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/hydrants/modals/inspections/InspectionCard.vue
// module id = 1802
// module chunks = 0